"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconPlusAlt = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12,2 C6.47,2 2,6.47 2,12 C2,17.53 6.47,22 12,22 C17.53,22 22,17.53 22,12 C22,6.47 17.53,2 12,2 Z M12.9970206,18.0740473 L11.0029794,18.0740473 L11.0029794,12.9970206 L5.92595275,12.9970206 L5.92595275,11.0029794 L11.0029794,11.0029794 L11.0029794,5.92595275 L12.9970206,5.92595275 L12.9970206,11.0029794 L18.0740473,11.0029794 L18.0740473,12.9970206 L12.9970206,12.9970206 L12.9970206,18.0740473 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconPlusAlt')(IconPlusAlt);